import firebase from "../components/firebase";
import { postError } from "../helper-methods/index";
export default class AnalyticsService {
  static shared = new AnalyticsService();

  register(customer) {
    // this.setFirebaseConfig();
    console.log("The customer in analytics service ::",customer)
    this.registerClevertap(customer);
  }

  setFirebaseConfig() {
    // Your web app's Firebase configuration
    var firebaseConfig = {
      apiKey: "AIzaSyAohKPHxnFL5ygMVanO9nZD-Dpu5her1wo",
      authDomain: "niyo-global.firebaseapp.com",
      databaseURL: "https://niyo-global.firebaseio.com",
      projectId: "niyo-global",
      storageBucket: "niyo-global.appspot.com",
      messagingSenderId: "888368629251",
      appId: "1:888368629251:web:5616a575cd42c1dfd87036",
      measurementId: "G-DYF16DQ4N7"
    };
    // Initialize Firebase
    if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);
  }

  registerClevertap(customer) {

    console.log("The register clevertap customer :",customer)
    const customerProps = {
      // wealth_mf_user_status: customer.status + customer.sub_status,
      // wealth_mf_onboarding_kyc_status: customer.kyc_status,
      wealth_mf_dob_year: customer.dob,
      // wealth_mf_resident: customer.investortype,
      // wealth_mf_name: customer.name,
      wealth_mf_occupation: customer.occupation,
      wealth_mf_gender: customer.gender,
      wealth_mf_marital_status: customer.martial_status,
      wealth_mf_income_range_lakhs: customer.income_range,
      // wealth_mf_pin: customer.pin,
      // wealth_mf_city: customer.city,
      // wealth_mf_state: customer.state,
      wealth_mf_bank_ifsc_prefix: customer.ifsc,
      wealth_mf_user_status: "customer.status + customer.sub_status",
      wealth_mf_onboarding_kyc_status: "customer.kyc_status",
      wealth_mf_dob_year: "customer.dob",
      wealth_mf_resident: "customer.investortype",
      wealth_mf_name: "customer.name",
      // wealth_mf_occupation: "customer.occupation",
      // wealth_mf_gender: "customer.gender",
      // wealth_mf_marital_status: "customer.martial_status",
      wealth_mf_income_range_lakhs: "customer.income_range",
      wealth_mf_pin: "customer.pin",
      wealth_mf_city: "customer.city",
      wealth_mf_state: "customer.state",
      wealth_mf_bank_ifsc_prefix: "customer.ifsc",
    };

    window.clevertap.profile.push({
      Site: {
        ...customer
      }
    });

   
    if(customer?.phone){
      console.log("The customer phone Inside ",customer.phone)
      firebase.analytics().setUserId(customer.phone);
    }
  

    firebase.analytics().setUserProperties(customerProps);
  }

  send(eventName, eventAttributes) {
    const platform=sessionStorage.getItem("platform")

    let browserName = sessionStorage.getItem("browserName");

    let browserVersion = sessionStorage.getItem("browserVersion");

    let isMobileBrowser = sessionStorage.getItem("isMobileBrowser");



    let eventAttributesTemp={

      platform,

      browserName,

      browserVersion,

      isMobileBrowser,

      ...eventAttributes

    }

    try {
      console.log("here",eventName, eventAttributes)
      window.clevertap.event.push(eventName, eventAttributesTemp);
      console.log("Clever tap after ")
    } catch (error) {
      postError(error);
    }
    // Analytics.logEvent(eventName, parameters;: props as [String; : NSObject;]?;)
    firebase.analytics().logEvent(eventName, eventAttributesTemp);
  }

  logout() {
    // ClevertapReact.logout()
  }

  
  initialiseUser(UserData) {
    console.log("The user data identity:",UserData)
    try {
      window.clevertap.onUserLogin.push({
        Site: {
          "Identity":UserData?.Id,
          "Email":UserData?.email ? UserData?.email:"",
          "Phone":UserData?.Phone ?"+91" + UserData?.Phone:"",
          "Name":UserData?.Name ? UserData?.Name:"N/A"
        }
      });
    } catch (error) {
      postError(error)
    }
  }
}
// export default new AnalyticsService();
